module.exports = __webpack_public_path__ + "img/coma-icom.977669b8.svg";